import { Button, IconButton } from '@mui/material'
import React from 'react'
import './Sidebar.css'
import AddIcon from '@mui/icons-material/Add';
import Sidebaroption from './Sidebaroption';
import InboxIcon from '@mui/icons-material/Inbox';
import StarIcon from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import NearMeIcon from '@mui/icons-material/NearMe';
import NoteIcon from '@mui/icons-material/Note';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import DuoIcon from '@mui/icons-material/Duo';
import PhoneIcon from '@mui/icons-material/Phone';
import { useDispatch } from 'react-redux';
import { OpenSendMessage } from './features/mailSlice';

function Sidebar() {
    const dispatch = useDispatch();
  
    return (
    <div className='sidebar'>
        <Button startIcon={<AddIcon fontSize='large'/>} className="sidebar_compose" 
        onClick={()=>dispatch(OpenSendMessage())}>Compose</Button>
        <Sidebaroption Icon={InboxIcon} title="Inbox" number={45} selected={true}/>
        <Sidebaroption Icon={StarIcon} title="Starred" number={45}/>
        <Sidebaroption Icon={AccessTimeIcon} title="Snoozed" number={45}/>
        <Sidebaroption Icon={LabelImportantIcon} title="Important" number={45}/>
        <Sidebaroption Icon={NearMeIcon} title="Sent" number={45}/>
        <Sidebaroption Icon={NoteIcon} title="Draft" number={45}/>
        <Sidebaroption Icon={ExpandMoreIcon} title="More" number={45}/>
        <div className='sidebar_footer'>
            <div className='sidebar_footericons'>
                <IconButton>
                    <PersonIcon/>
                </IconButton>
                <IconButton>
                    <DuoIcon/>
                </IconButton>
                <IconButton>
                    <PhoneIcon/>
                </IconButton>
            </div>
        </div>
    </div>
    
  )
}

export default Sidebar